import { ReactNode, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { LoadingContainer } from "../../../../app/LoadingContainer";
import { impossible } from "../../../../app/Utils";
import { selectDocument } from '../../documentSlice';
import { loadDeviations } from "./deviationsApi";

export const DeviationsLoader = (props:  { children: ReactNode } ) => {
    const dispatch = useAppDispatch()
    const documentId = useAppSelector(state => selectDocument(state).doc?.header.id) ?? impossible()

    const loaded = useAppSelector(state => selectDocument(state).doc?.deviations.loaded) ?? false

    useEffect(() => {
        if (!loaded) {
            dispatch(loadDeviations({ documentId }))
        }
    }, [loaded])

    if (loaded) return <>{props.children}</>
    else return <LoadingContainer />
}
